import type { IStorage } from './types';
import { getCompatibleStorage } from './utils';

export default function StorageWrapper(
  getStorageImplementation: typeof getCompatibleStorage
): IStorage {
  let storagePromise;
  function getStorage() {
    if (!storagePromise) {
      storagePromise = getStorageImplementation();
    }
    return storagePromise;
  }

  return {
    getItem: (key: string, callback?: (err: any, res: any) => void) =>
      getStorage().then((storage) => storage.getItem(key, callback)),
    setItem: (key: string, value: string, callback?: (err: any, res: any) => void) =>
      getStorage().then((storage) => storage.setItem(key, value, callback)),
    removeItem: (key: string, callback?: (err: any, res: any) => void) =>
      getStorage().then((storage) => storage.removeItem(key, callback)),
    getAllKeys: (callback?: (err: any, res: any) => void) =>
      getStorage().then((storage) => storage.getAllKeys(callback)),
  };
}
